import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CarrinhoProvider } from "./context/CarrinhoContext";
import { ProdutosProvider } from "./context/ProdutosContext";
import { PedidosProvider } from "./context/PedidosContext";
import { UserProvider } from "./context/UserContext";
import { RestauranteProvider } from "./context/RestauranteContext"; 
import { ProducaoProvider } from "./context/ProducaoContext";
import { RotinasProvider } from "./context/RotinasContext";
import { AproveitamentoProvider } from "./context/AproveitamentoContext";
import { NotificacaoProvider } from "./context/NotificacaoContext";
import { LoadingProvider } from './context/LoadingContext'; 

const disableWebSocket = process.env.REACT_APP_DISABLE_WEBSOCKET === 'true';

if (disableWebSocket && typeof window !== 'undefined') {
  window._originalWebSocket = window.WebSocket;

  window.WebSocket = function(url) {
    console.log('[WebSocket Mock] Conexão bloqueada (não utilizada no projeto)');
    return {
      send: () => {},
      close: () => {},
      onopen: () => {},
      onmessage: () => {},
      onerror: () => {},
      onclose: () => {},
    };
  };
  window.WebSocket.CONNECTING = 0;
  window.WebSocket.OPEN = 1;
  window.WebSocket.CLOSING = 2;
  window.WebSocket.CLOSED = 3;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <UserProvider>
      <RestauranteProvider>
        <NotificacaoProvider>
          <ProducaoProvider>
            <RotinasProvider>
              <AproveitamentoProvider>
                <ProdutosProvider>
                  <CarrinhoProvider>
                    <PedidosProvider>
                      <LoadingProvider>
                        <App />
                        </LoadingProvider>
                    </PedidosProvider>
                  </CarrinhoProvider>
                </ProdutosProvider>
              </AproveitamentoProvider>
            </RotinasProvider>
          </ProducaoProvider>
        </NotificacaoProvider>
      </RestauranteProvider>
    </UserProvider>
);

reportWebVitals();